<template>
  <v-container>
    <div v-if="evaluationById">
      <v-layout row mb-3>
        <v-flex xs12>
          <div >
            <h1>
              <span class="font-weight-thin">{{$t('evaluationHeader')}}</span>
              {{evaluationById.templateByTemplateId.title}}
            </h1>
          </div>
        </v-flex>
      </v-layout>
      <div >
        <p class="mb-1 pl-1 headline" v-if="evaluationById.teamByTeamId">
          {{evaluationById.teamByTeamId.name}}
        </p>
        <v-layout row fill-height align-center wrap mb-5>
          <v-flex ma-1 v-for="(node, index) in sortedParticipations" :key="index">
            <v-card>
              <v-card-title primary-title >
                <div>
                  <div :style="'color: ' + node.participantRoleByRoleId.color">
                    <v-icon :style="'color: ' + node.participantRoleByRoleId.color">account_box</v-icon>
                    <span class="title">{{node.participantRoleByRoleId.title}}</span>
                  </div>
                  <div>
                    <span class="subheading">
                      {{node.participantByParticipantId.fullName}}
                    </span>
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>

        <div>
          <!-- Observations -->
          <div v-for="category in formStructure" :key="category.id" class="ma-1 mb-4 v-card v-sheet theme--light elevation-2">
            <div>
              <v-container>
                <v-layout row wrap>
                  <v-flex xs11 pt-3 @click="clickCategory(category)">
                    <span class="body-2"><span v-if="category.supercategoryIdsList.length >0">{{getSuperCategoryTitleFromSub(category)}}: </span>{{category.title}}</span>
                    <v-tooltip bottom 
                      max-width="75%"
                      v-if="category.info && !showInfo[category.id]">
                      <v-icon 
                        slot="activator" 
                        class="ml-2" style="vertical-align: middle" color="blue-grey lighten-3">info</v-icon>
                      <vue-markdown class="info-tooltip category-info-tooltip">{{category.info}}</vue-markdown>
                    </v-tooltip>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs1 text-xs-right>
                    <v-btn
                      class="comment-btn"
                      fab
                      color="blue-grey"
                      :dark="checkForCommentsOnCategory(category.id)"
                      small
                      :flat="!checkForCommentsOnCategory(category.id)"
                      @click="openCommentDialog(null, category)"
                    >
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                  </v-flex>
                  
                </v-layout>
                <v-slide-y-transition>
                  <v-layout row wrap mt-1
                    v-show="showInfo[category.id]"
                    class="grey--text text--darken-1"
                    @click="clickCategory(category)">
                    <v-flex xs11>
                      <vue-markdown class="info-text category-info-text">{{category.info}}</vue-markdown>
                    </v-flex>
                  </v-layout>
                </v-slide-y-transition>
                <div v-for="(indicator,indicatorIndex) in category.indicators" :key="indicator.id">
                  <v-divider v-if="indicatorIndex != 0"></v-divider>
                  <v-layout row wrap mt-3>
                    <v-flex xs1 pt-3 @click="clickIndicator(indicator)">
                      <p class="body-1 text-xs-center">{{indicator.score}}</p>
                    </v-flex>
                    <v-flex xs11 sm10 md7 lg8 pt-3 @click="clickIndicator(indicator)">
                      <span class="body-1">{{indicator.title}}</span>
                      <span v-if="indicator.teamBased">
                        <span v-for="role in getIndicatorRoles(indicator)" :key="role.id" :style="'color: ' + role.color">
                          {{role.title}}
                        </span>
                      </span>
                      <v-tooltip bottom
                        max-width="75%"
                        v-if="indicator.info && !showInfo[indicator.id]">
                        <v-icon 
                          slot="activator"
                          class="ml-2" style="vertical-align: middle" color="blue-grey lighten-3">info</v-icon>
                        <vue-markdown class="info-tooltip indicator-info-tooltip">{{indicator.info}}</vue-markdown>
                      </v-tooltip>

                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex md4 lg3 text-xs-right>

                      <v-btn v-if="indicator.teamBased"
                        class="team-btn"
                        color="primary"
                        :disabled="checkNa(indicator.id)"
                        :outline="!checkIndicatorStatus( indicator.id) "
                        :dark="checkIndicatorStatus( indicator.id) && !checkNa(indicator.id)"
                        :flat="!checkIndicatorStatus( indicator.id) "
                        @click="indicatorButtonPressed(indicator.id)"
                      >
                        <v-icon v-if="checkIndicatorStatus( indicator.id) && !checkNa(indicator.id)" dark>check</v-icon>
                      </v-btn>

                      <v-btn 
                        class="na-btn"
                        color="blue-grey"
                        :flat="!checkNa(indicator.id)"
                        :dark="checkNa(indicator.id)"
                        @click="naButtonPressed(indicator.id)"
                      >n/a</v-btn>

                      <v-btn
                        class="comment-btn"
                        small
                        fab
                        color="blue-grey"
                        :dark="checkForCommentsOnIndicator(indicator.id)"
                        :flat="!checkForCommentsOnIndicator(indicator.id)"
                        @click="openCommentDialog(indicator)"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>

                    </v-flex>
                  </v-layout>
                  <v-slide-y-transition>
                    <v-layout row wrap mt-1 
                      v-if="showInfo[indicator.id]" class="grey--text text--darken-1"
                      @click="clickIndicator(indicator)">
                      <v-flex xs11 offset-xs1>
                        <vue-markdown class="info-text indicator-info-text">{{indicator.info}}</vue-markdown>
                      </v-flex>
                    </v-layout>
                  </v-slide-y-transition>
                  <v-layout mb-3>
                    <v-flex xs12 text-xs-right v-if="!indicator.teamBased" class="non-team-based">
                      <span v-for="participationNode in sortedParticipations" :key="participationNode.participantByParticipantId.id">
                          <span v-if="participationNode.participantByParticipantId">
                            <v-btn class="role-btn"
                              :style="roleObservationButtonStyle(indicator, participationNode)"
                              :outline="checkNa(indicator.id) || !checkIndicatorStatus(indicator.id, participationNode.participantByParticipantId.id) "
                              :disabled="checkNa(indicator.id) || checkNa(indicator.id, participationNode.participantByParticipantId.id)"
                              :dark="checkIndicatorStatus(indicator.id, participationNode.participantByParticipantId.id) && !checkNa(indicator.id, participationNode.participantByParticipantId.id)"
                              :flat="checkNa(indicator.id) || !checkIndicatorStatus(indicator.id, participationNode.participantByParticipantId.id) "
                              @click="indicatorButtonPressed(indicator.id, participationNode.participantByParticipantId.id)"
                            >
                            {{participationNode.participantRoleByRoleId.title}}</v-btn>
                            <v-btn class="na-btn role-na-btn"
                              color="blue-grey lighten-2"
                              :outline="checkNa(indicator.id) || !checkNa(indicator.id, participationNode.participantByParticipantId.id)"
                              :disabled="checkNa(indicator.id)"
                              :dark="checkNa(indicator.id, participationNode.participantByParticipantId.id)"
                              @click="naButtonPressed(indicator.id, participationNode.participantByParticipantId.id)"
                            >n/a</v-btn>
                          </span>
                      </span>

                      <!-- "button" as a spacer to match edit button above -->
                      <v-btn small fab flat color="transparent">
                        <v-icon dark>edit</v-icon>
                      </v-btn>

                    </v-flex>
                  </v-layout> 
                </div>
              </v-container>
            </div>
          </div>
          <CommentDialog 
            ref="commentDialog"
            v-bind:allComments="allComments"
            v-bind:evaluationId="evaluationId"
            v-bind:currentUser="currentUser"
            v-on:commentEvent="updateComments"></CommentDialog>
        </div>
        <v-layout row mt-3>
          <v-flex xs4>
            <v-btn block color="danger" dark @click="discardEvaluation">{{$t('discardEvaluation')}}</v-btn>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs4>
            <v-btn block color="primary" dark @click="finishEvaluation">{{$t('finishEvaluation')}}</v-btn>
          </v-flex>
          <!--
          <v-flex xs4 v-else>
            <v-btn block color="primary" dark @click="goToResult">{{$t('viewResult')}}</v-btn>
          </v-flex>
          -->
        </v-layout>
        <confirm-dialog
          ref="confirmDiscard"
          :title="$t('discardEvaluation')"
          :label="$t('yesDiscardEvaluation')"
          color="danger"
        >
          {{$t('confirmDiscardEvaluation')}}
        </confirm-dialog>
      </div>
    </div>
  </v-container>
</template>

<style scoped>
.na-btn {
  margin-left: 0;
  min-width: 55px;
}
.team-btn {
  margin-right: 2px;
}
.role-btn {
  margin-right: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}
.role-na-btn {
  margin-left: 0;
  border-left: none;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  border-color: #ccc;
}
.info-tooltip {
  font-size: 14px;
  padding: 10px;
}
</style>

<script>
//import { templateByIdQuery } from "@/graphql/templateQueries.gql";
import {
  //newEvalMutation,
  //newParticipationMutation,
  newObservationMutation,
  deleteObservationByIdMutation,
  updateEvaluationEndTimeMutation,
  categoriesQuery,
  participationsByEvaluationIdQuery,
  evaluationByIdQuery,
  allEvaluationsBasicQuery,
  evaluationTrendQuery,
  deleteEvaluationMutation,
} from "@/graphql/evaluationQueries.gql";
import { observationByEvaluationIdQuery } from "@/graphql/evaluationQueries.gql";
import { commentsByEvaluationIdQuery } from "@/graphql/commentQueries.gql";
import {
  allParticipantsQuery,
  allParticipantRolesQuery,
  allTeamsQuery
} from "@/graphql/participantQueries.gql";
import CommentDialog from '@/components/CommentDialog.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    CommentDialog,
    ConfirmDialog,
    VueMarkdown
  },
  apollo: {
    evaluationById:{
        query: evaluationByIdQuery,
        // Reactive parameters
        variables() {
          // Use vue reactive properties here
          return {
              evaluationId: this.evaluationId,
          }
        },
      },
    allObservations: {
      query: observationByEvaluationIdQuery,
      variables() {
        return {
          evaluationId: this.evaluationId
        };
      }
    },
    allComments: {
      query: commentsByEvaluationIdQuery,
      variables() {
        return {
          evaluationId: this.evaluationId
        };
      }
    },
    allParticipations: {
      query: participationsByEvaluationIdQuery,
      variables() {
        return {
          evaluationId: this.evaluationId
        };
      }
    },
    allParticipants: allParticipantsQuery,
    allParticipantRoles: allParticipantRolesQuery,
    allCategories: categoriesQuery,
    allTeams: allTeamsQuery
  },
  methods: {
    clickIndicator(indicator) {
      if (indicator.info) {
        this.$set(this.showInfo, indicator.id, !this.showInfo[indicator.id])
      }
    },
    clickCategory(category) {
      if (category.info) {
        this.$set(this.showInfo, category.id, !this.showInfo[category.id])
      }
    },
    indicatorButtonPressed( indicatorId, participantId = null) {
      for (var index in this.allObservations.nodes) {
        var observation = this.allObservations.nodes[index];
        if (
          observation.indicatorId == indicatorId &&
          observation.participantId == participantId
        ) {
          this.deleteObservation(observation.id);
          return;
        } 
      }
      this.addObservation(participantId, indicatorId);
    },
    naButtonPressed(indicatorId, participantId = null) {
      var promise = Promise.resolve()
      var foundExistingNa = false
      const indicator = this.allIndicatorsInTemplate.find(i => i.id === indicatorId)
      for (const observation of this.allObservations.nodes) {
        if(participantId){
          if (observation.indicatorId == indicatorId && observation.participantId === participantId) {
            promise = promise.then(() => this.deleteObservation(observation.id))
            if (observation.na) foundExistingNa = true
          }  
        }else {
          if (observation.indicatorId == indicatorId && (!observation.participantId || !indicator.teamBased)) {
            promise = promise.then(() => this.deleteObservation(observation.id))
            if (observation.na) foundExistingNa = true
          }
        }
      }
      if (!foundExistingNa) {
        if (!indicator.teamBased && participantId === null) {
          // Indicator-level N/A button for non-team based indicator = N/A for all participants
          for (const roleId of indicator.roleIdsList) {
            const participation = this.evaluationById.participationsByEvaluationId.nodes.find(p => p.participantRoleByRoleId.id === roleId)
            if (participation && participation.participantByParticipantId) {
              promise = promise.then(() => this.addObservation(participation.participantByParticipantId.id, indicatorId, true))
            }
          }
        } else {
          promise = promise.then(() => this.addObservation(participantId, indicatorId, true))
        }
      }
    },
    checkNa(indicatorId, participantId = null) {
      if (!this.allObservations) return false
      const observations = this.allObservations.nodes.filter(o => o.indicatorId === indicatorId)
      var naParticipantIds = []
      for (const observation of observations) {
        if (participantId) {
          if (observation.na && observation.participantId === participantId) return true
        } else {
          if (observation.na && !observation.participantId) return true
          if (observation.na && observation.participantId) naParticipantIds.push(observation.participantId)
        }
      }
      if (naParticipantIds.length > 0) {
        // Check for non-team based indicator where N/A is true for all participants
        const indicator = this.allIndicatorsInTemplate.find(i => i.id === indicatorId)
        if (naParticipantIds.length >= indicator.roleIdsList.length) return true
      }
      return false;
    },
    addObservation(participantId = null, indicatorId, na = false) {
      const observation = {
        id: this.guid(),
        userId: this.currentUser.id,
        evaluationId: this.evaluationId,
        participantId: participantId,
        indicatorId: indicatorId,
        na: na
      }

      // Be optimistic
      const store = this.$apollo.getClient().cache
      const data = store.readQuery({ 
        query: observationByEvaluationIdQuery,
        variables: { evaluationId: this.evaluationId },
      })
      data.allObservations.nodes.push({...observation, nodeId: observation.id, __typename: "Observation"})
      store.writeQuery({ 
        query: observationByEvaluationIdQuery, 
        variables: { evaluationId: this.evaluationId },
        data
      })

      return this.$apollo
        .mutate({
          mutation: newObservationMutation,
          variables: {
            ObservationData: { observation }
          },
          /*
          update: (store, { data: { createObservation } }) => {
            // Read the data from our cache for this query.
            const data = store.readQuery({ 
              query: observationByEvaluationIdQuery,
              variables: {
                evaluationId: this.evaluationId
              },
            })
            console.log(createObservation.observation)
            // Add our tag from the mutation to the end
            data.allObservations.nodes.push(createObservation.observation)
            // Write our data back to the cache.
            store.writeQuery({ 
              query: observationByEvaluationIdQuery, 
              variables: {
                evaluationId: this.evaluationId
              },
              data
            })
          },
          optimisticResponse: {
            __typename: 'Mutation',
            createObservation: {
              __typename: 'ObservationInput',
              observation: {
                __typename: 'Observation',
                ...observation
              }
            },
          },
          */
        })
        .then(data => {
          console.log(data)
          //this.$apollo.queries.allObservations.refetch();
        })
        .catch(error => {
          console.error(error);
          this.allObservations = null
          this.$apollo.queries.allObservations.refetch();
        });
      //
    },
    deleteObservation(observationId) {
      // Be optimistic
      const store = this.$apollo.getClient().cache
      const data = store.readQuery({ 
        query: observationByEvaluationIdQuery,
        variables: { evaluationId: this.evaluationId },
      })
      const index = data.allObservations.nodes.findIndex(o => o.id === observationId)
      data.allObservations.nodes.splice(index, 1)
      store.writeQuery({ 
        query: observationByEvaluationIdQuery, 
        variables: { evaluationId: this.evaluationId },
        data
      })

      return this.$apollo
        .mutate({
          mutation: deleteObservationByIdMutation,
          variables: {
            deleteObservationData: {
              id: observationId
            }
          }
        })
        .then(data => {
          console.log(data)
          //this.$apollo.queries.allObservations.refetch()
        })
        .catch(error => {
          console.error(error);
          this.allObservations = null
          this.$apollo.queries.allObservations.refetch();
        });
    },
    openCommentDialog(indicator = null, category = null, participant = null) {
      this.$refs.commentDialog.openDialog(indicator, category, participant)
      this.dialog = true
    },
    updateComments(){
      this.$apollo.queries.allComments.refetch()
    },
    checkForCommentsOnIndicator(indicatorId, participantId = null) {
      if(this.allComments){
        for (var i in this.allComments.nodes) {
          if (
            this.allComments.nodes[i].indicatorId === indicatorId
          ) {
            if(participantId){
              if(
                this.allComments.nodes[i].participantId === participantId){
                  return true
                } else {
                  return false
                }
            }
            return true;
          }
        }
      }
      return false;
    },
    getCommentsOnIndicator(indicatorId, participantId = null) {
      var comments = [];
      for (var i in this.allComments.nodes) {
        if (this.allComments.nodes[i].indicatorId === indicatorId) {
          if( !participantId ){
            comments.push(this.allComments.nodes[i]);
          } else if(this.allComments.nodes[i].participantId === participantId){
            comments.push(this.allComments.nodes[i]);
          }
        }
      }
      return comments;
    },
    checkForCommentsOnCategory(categoryId) {
      if(this.allComments){
        for (var i in this.allComments.nodes) {
          if (
            categoryId && 
            this.allComments.nodes[i].categoryId === categoryId
          ) {
            return true;
          }
        }
      }
      return false;
    },
    getCommentsOnCategory(categoryId) {
      var comments = [];
      for (var i in this.allComments.nodes) {
        if (this.allComments.nodes[i].categoryId === categoryId) {
          comments.push(this.allComments.nodes[i]);
        }
      }
      return comments;
    },
    checkIndicatorStatus(indicatorId, participantId = null) {
      if(this.allObservations){

        for (var index in this.allObservations.nodes) {
          if(this.allObservations.nodes[index].indicatorId == indicatorId){
            
            if (participantId && 
              this.allObservations.nodes[index].participantId == participantId && 
              this.allObservations.nodes[index].indicatorId == indicatorId &&
              this.allObservations.nodes[index].na === false 
            ) {
              return true;
            } else if(!participantId &&this.allObservations.nodes[index].indicatorId == indicatorId){
              return true;
            }
          }
        } 
      }
      return false;
    },
    addParticipant() {
      this.selectedParticipants.push({
        id: this.selectedParticipants.length + 1
      });
    },
    removeParticipant(index) {
      if (this.selectedParticipants.length > index) {
        this.selectedParticipants.splice(index, 1);
      }
    },
    participantAlreadySelected(id) {
      console.log(id);
      for (var p in this.selectedParticipants) {
        if (id === p.participant.id) {
          return true;
        }
      }
      return false;
    },
    getIndicatorRoles(indicator) {
      var roles = []
      if (this.allParticipantRoles) {
        indicator.roleIdsList.forEach(roleId => {
          var found = this.allParticipantRoles.nodes.find(function(role) {
            return role.id === roleId
          })
          roles.push(found)
        })
      }
      return roles
    },
    createEval() {
      this.addNewEvaluation();
    },
    finishEvaluation() {
      this.$apollo
        .mutate({
          mutation: updateEvaluationEndTimeMutation,
          variables: {
            endTimeOfEvaluation: {
              id: this.evaluationId,
              evaluationPatch: {
                endTime: this.moment().format()
              }
            }
          },
          refetchQueries: [ 
            { query: allEvaluationsBasicQuery },
            { query: evaluationTrendQuery, variables: { templateId: this.evaluationById.templateByTemplateId.id } }
          ],
        })
        .then(() => {
          this.$router.push({
            name: "result",
            params: { evaluationId: this.evaluationId }
          }); //params: ...
        });
    },
    discardEvaluation() {
      this.$refs.confirmDiscard.open().then(() => {
        this.$apollo.mutate({
          mutation: deleteEvaluationMutation,
          variables: { evaluationId: this.evaluationId },
          refetchQueries: [ 
            { query: allEvaluationsBasicQuery },
            { query: evaluationTrendQuery, variables: { templateId: this.evaluationById.templateByTemplateId.id } }
          ],
        }).then(() => {
          this.$router.push({ name: "home" });
        })
      })
    },
    getSuperCategoryTitleFromSub(category){
      var cat = null
      if(this.allCategories && category.supercategoryIdsList.length > 0){
        cat = this.allCategories.nodes.find(superCategory => {
          return superCategory.id === category.supercategoryIdsList[0]
        })
        if(cat){
          cat = cat.title
        }
      }
      return cat
    },
    roleObservationButtonStyle(indicator, participation) {
      if (this.checkNa(indicator.id) || this.checkNa(indicator.id, participation.participantByParticipantId.id)) return {}
      const role = participation.participantRoleByRoleId
      if (this.checkIndicatorStatus(indicator.id, participation.participantByParticipantId.id)) {
        return {
          'background-color': role.color
        }
      } else {
        return {
          'color': role.color,
          'border-color': role.color
        }
      }
    },
    goToResult(){
      this.$router.push({
        name: "result",
        params: { evaluationId: this.evaluationId }
      }); //params: ...
    },
    goBackHome() {
      this.$router.push({ name: "home" });
    },
    guid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      }
    },
    mounted() {
      if (!this.evaluationId) {
        this.$router.push({ name: "home" });
      }
  },
  computed: {
    currentUser() { return this.$store.state.currentUser },
    sortedParticipations(){
      if (!this.evaluationById) return []
      const participations = this.evaluationById.participationsByEvaluationId.nodes
      return participations.concat().sort((a,b) => a.participantRoleByRoleId.sortWeight - b.participantRoleByRoleId.sortWeight)
    },
    allIndicatorsInTemplate() {
      const allIndicatorsInTemplate = []
      this.evaluationById.templateByTemplateId.templateRowsByTemplateId.nodes.forEach(node =>{
        allIndicatorsInTemplate.push(node.indicatorByIndicatorId)
      })
      return allIndicatorsInTemplate
    },
    allCategoriesInTemplate() {
      const allCategoriesInTemplate = []
      if(this.allCategories){
        for(const indicator of this.allIndicatorsInTemplate){
          for(var indcat of indicator.indicatorCategoriesByIndicatorIdList){
            var cat = this.allCategories.nodes.find( category => category.id === indcat.categoryId)
            if(!allCategoriesInTemplate.some( category => category.id === cat.id )){
              allCategoriesInTemplate.push(cat)
            }
          }
        }
      }
      return allCategoriesInTemplate
    },
    formStructure() {
      var formStructure = [] 

      for(const category of this.allCategoriesInTemplate){
        if(category.type === "cr" || category.type === "event_detail" || category.title === "Generella kriterier" || category.title === "Processförståelse") {
          formStructure.push(category)
          category.indicators = []
          for(const formIndicator of this.allIndicatorsInTemplate){
            if( formIndicator.indicatorCategoriesByIndicatorIdList.find(indcat => indcat.categoryId === category.id)){
              category.indicators.push(formIndicator)
            }
          }
        }
      }

      formStructure.sort((a, b) => a.sortWeight - b.sortWeight)
      for (const category of formStructure) {
          category.indicators.sort((a, b) => {
              var a_indcat = a.indicatorCategoriesByIndicatorIdList.find(indcat => indcat.categoryId === category.id)
              var b_indcat = b.indicatorCategoriesByIndicatorIdList.find(indcat => indcat.categoryId === category.id)
              return (a_indcat ? a_indcat.sortWeight : 0) - (b_indcat ? b_indcat.sortWeight : 0)
          })
      }

      return formStructure
    },
  },
  data() {
    return {
      templateById: null,
      allParticipants: null,
      allParticipantRoles: null,
      selectedParticipant: null,
      selectedParticipantRole: null,
      //evaluationId: null,
      observations: null,
      localObservations: null,
      dialog: false,
      commentingOnParticipant: null,
      commentingOnIndicator: null,
      commentingOnCategory: null,
      commentTextInput: null,
      mutatingComment: null,
      allParticipations:null,
      selectedTeam:null,
      showInfo: {},
    };
  },
  props: ["evaluationId"]
};
</script>
